import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Store} from "@ngxs/store";
import {AuthState} from "../../states/auth.state";
import {AuthenticationService} from "../../service/auth.service";
import {AccountState} from "../../states/account.state";
import {SendToast} from "../../actions/toast.actions";
import {ToastType} from "../../actions/core.actions";
import Swal from "sweetalert2";
import {SwalUtil} from "../../util/swal-util";

@Injectable({
    providedIn: 'root'
})
export class IdentityVerificationGuard  {

  constructor(
    private router: Router,private store:Store,
    private authenticationService: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const accountStatus = this.store.selectSnapshot(AccountState.getAccountStatus);
    if (accountStatus) {
      const idLevel = Number(accountStatus.level.id);
     if(idLevel < 1) {
       Swal.fire(SwalUtil.getVerificarCuentaOptions()).then((result) => {
         if (result.isConfirmed) {
           this.router.navigate(['/verify-account'])
         }
       })
       return false;
     }  else if(idLevel == 1) {
       Swal.fire(SwalUtil.getVerificarIdentidadOptions()).then((result) => {
         if (result.isConfirmed) {
           this.router.navigate(['/home'])
         }
       })
       return false;
     } else {
       return true;
     }
    } else {
      // logged in so return true
      return true;
    }
    return false;
  }

}
